import React from 'react';

import Typography from '@material-ui/core/Typography';


function Skills() {
 return (
  <div>
             <h4 className="sdsd">Taks that I have engaged in</h4>
            <Typography color="textSecondary" variant="body2">
            -- Web Design and Full Stack web developement.
            </Typography>
            <Typography color="textSecondary" variant="body2">
            -- Worked as intern Platinum Credit Limited
            </Typography>
            <Typography color="textSecondary" variant="body2">
            -- Enumarator: Census 2019.
            </Typography>
            <Typography color="textSecondary" variant="body2">
            -- Blaze BYOB by Safaricom Creation Camp - Technology pod.
            </Typography>
            <Typography color="textSecondary" variant="body2">
            -- Ajira Digital Trainee and Freelancer.
            </Typography>
            <Typography color="textSecondary" variant="body2">
            -- Class Asignments and Group Projects on Web development and Ecomerce.
            </Typography>
  </div>
 )
}

export default Skills
